import { View } from "binder"
import { FormBuilderComponentView, FormBuilderElement } from "src/formBuilder/structure/element";
import { ButtonElement } from "./button-viewModel"

export class ButtonView extends FormBuilderComponentView<ButtonElement>{
    GetViewUniqueId(): string {
        return "V-F470BF47-B480-4AE3-8632-7330F6A903AA"
    }
    loadHtml(): string {
        let element = require('./button.html').default;
        let style = require('./button.less');
        return element;
    }
    constructor() {
       super();
    }

    public set Content(v: FormBuilderElement) { this._Content = v; } public get Content(): FormBuilderElement { return this._Content;} private _Content: FormBuilderElement;
    public set OnClick(v: any) { this._OnClick = v; } public get OnClick(): any { return this._OnClick;} private _OnClick: any;

}
